import React, { useState } from 'react';
import { Settings, Save, AlertCircle } from 'lucide-react';

const PlatformSettingsPage: React.FC = () => {
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const [settings, setSettings] = useState({
    freeMaxGroups: 1,
    freeMaxPlayers: 50,
    freeHasResenha: false,
    monthlyMaxGroups: 3,
    monthlyMaxPlayers: 150,
    monthlyHasResenha: true,
    annualMaxGroups: 10,
    annualMaxPlayers: 500,
    annualHasResenha: true,
    trialDays: 7,
    maintenanceMode: false,
  });

  const handleSave = async () => {
    setSaving(true);
    setSuccess(false);

    await new Promise(resolve => setTimeout(resolve, 1000));

    setSuccess(true);
    setSaving(false);

    setTimeout(() => setSuccess(false), 3000);
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-white">Configurações da Plataforma</h1>

      {success && (
        <div className="p-4 bg-green-500/20 border border-green-500 rounded-lg flex items-center gap-3">
          <AlertCircle className="w-5 h-5 text-green-400" />
          <p className="text-green-400">Configurações salvas com sucesso!</p>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Plano Gratuito</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Grupos</label>
              <input
                type="number"
                value={settings.freeMaxGroups}
                onChange={(e) => setSettings({ ...settings, freeMaxGroups: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Jogadores</label>
              <input
                type="number"
                value={settings.freeMaxPlayers}
                onChange={(e) => setSettings({ ...settings, freeMaxPlayers: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="freeResenha"
                checked={settings.freeHasResenha}
                onChange={(e) => setSettings({ ...settings, freeHasResenha: e.target.checked })}
                className="w-4 h-4 text-amber-500 bg-slate-900 border-slate-700 rounded focus:ring-amber-500"
              />
              <label htmlFor="freeResenha" className="text-slate-300 text-sm">
                Acesso à Resenha
              </label>
            </div>
          </div>
        </div>

        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Plano Mensal</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Grupos</label>
              <input
                type="number"
                value={settings.monthlyMaxGroups}
                onChange={(e) => setSettings({ ...settings, monthlyMaxGroups: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Jogadores</label>
              <input
                type="number"
                value={settings.monthlyMaxPlayers}
                onChange={(e) => setSettings({ ...settings, monthlyMaxPlayers: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="monthlyResenha"
                checked={settings.monthlyHasResenha}
                onChange={(e) => setSettings({ ...settings, monthlyHasResenha: e.target.checked })}
                className="w-4 h-4 text-amber-500 bg-slate-900 border-slate-700 rounded focus:ring-amber-500"
              />
              <label htmlFor="monthlyResenha" className="text-slate-300 text-sm">
                Acesso à Resenha
              </label>
            </div>
          </div>
        </div>

        <div className="bg-slate-800 rounded-lg border border-slate-700 p-6">
          <h2 className="text-lg font-semibold text-white mb-4">Plano Anual</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Grupos</label>
              <input
                type="number"
                value={settings.annualMaxGroups}
                onChange={(e) => setSettings({ ...settings, annualMaxGroups: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div>
              <label className="block text-slate-300 mb-2 text-sm">Máximo de Jogadores</label>
              <input
                type="number"
                value={settings.annualMaxPlayers}
                onChange={(e) => setSettings({ ...settings, annualMaxPlayers: Number(e.target.value) })}
                className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
              />
            </div>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="annualResenha"
                checked={settings.annualHasResenha}
                onChange={(e) => setSettings({ ...settings, annualHasResenha: e.target.checked })}
                className="w-4 h-4 text-amber-500 bg-slate-900 border-slate-700 rounded focus:ring-amber-500"
              />
              <label htmlFor="annualResenha" className="text-slate-300 text-sm">
                Acesso à Resenha
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-slate-800 rounded-lg border border-slate-700 p-6">
        <h2 className="text-lg font-semibold text-white mb-4">Configurações Gerais</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-slate-300 mb-2 text-sm">Duração do Trial (dias)</label>
            <input
              type="number"
              value={settings.trialDays}
              onChange={(e) => setSettings({ ...settings, trialDays: Number(e.target.value) })}
              className="w-full px-4 py-2 bg-slate-900 border border-slate-700 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-amber-500"
            />
          </div>

          <div>
            <label className="block text-slate-300 mb-2 text-sm">Modo Manutenção</label>
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="maintenanceMode"
                checked={settings.maintenanceMode}
                onChange={(e) => setSettings({ ...settings, maintenanceMode: e.target.checked })}
                className="w-4 h-4 text-amber-500 bg-slate-900 border-slate-700 rounded focus:ring-amber-500"
              />
              <label htmlFor="maintenanceMode" className="text-slate-300 text-sm">
                Ativar modo de manutenção
              </label>
            </div>
            {settings.maintenanceMode && (
              <p className="text-amber-400 text-sm mt-2">
                Usuários regulares não poderão acessar a plataforma
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="flex justify-end">
        <button
          onClick={handleSave}
          disabled={saving}
          className="flex items-center gap-2 px-6 py-3 bg-amber-500 hover:bg-amber-600 disabled:bg-slate-700 disabled:text-slate-500 text-white rounded-lg transition-colors font-medium"
        >
          <Save className="w-5 h-5" />
          {saving ? 'Salvando...' : 'Salvar Configurações'}
        </button>
      </div>
    </div>
  );
};

export default PlatformSettingsPage;
